import { render } from "./RegisterSubscribe.view.vue?vue&type=template&id=62d94e06"
import script from "./RegisterSubscribe.view.vue?vue&type=script&lang=js"
export * from "./RegisterSubscribe.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__